import "./ErrorPage.css";

function ErrorPage() {
    return (
        <div>
            <h3>404 Not Found</h3>
            <p>Sorry, the page you are looking for does not exist.</p>
            <p>
                <a href="/">Return to the homepage</a>
            </p>
        </div>
    );
}

export default ErrorPage;